import React from 'react';

const VeraRubin = () => (
  <article className="news-article-body">
    <p className="news-lead">
      At GTC 2025, Jensen Huang announced NVIDIA's next GPU architecture after Blackwell:
      Vera Rubin, named after the astronomer who discovered dark matter. It's scheduled
      for the second half of 2026, and on paper it's a massive leap - the Rubin Ultra NVL576
      configuration is projected to deliver 15,000 TOPS of AI compute. For reference,
      Blackwell GB200 NVL72 does around 1,440 TOPS. That's roughly 10x in one generation.
    </p>

    <h2>What's actually new in Vera Rubin</h2>
    <p>
      The "Vera" part refers to the CPU, and "Rubin" to the GPU - NVIDIA is naming their
      combined superchip architectures after scientists. Key changes from Blackwell:
    </p>
    <ul>
      <li><strong>New memory technology:</strong> HBM4 instead of HBM3e - higher bandwidth, better power efficiency</li>
      <li><strong>New interconnect:</strong> NVLink 6 doubles the bandwidth between GPUs compared to Blackwell's NVLink 5</li>
      <li><strong>Vera CPU:</strong> A new NVIDIA-designed ARM-based CPU replacing the Grace CPU, with better AI-specific performance</li>
      <li><strong>Rubin Ultra NVL576:</strong> The highest-end configuration packs 576 GPUs in a single "domain" - essentially a rack-scale supercomputer</li>
    </ul>

    <h2>The 2-year cadence</h2>
    <p>
      NVIDIA has shifted to a roughly annual architecture cadence - Ampere (2020), Hopper
      (2022), Blackwell (2024), Vera Rubin (2026), Feynman (2028). This is faster than
      the traditional 2-year GPU cycle and puts immense pressure on competitors.
    </p>
    <p>
      For data centre operators, this creates a real planning problem: by the time you've
      deployed a Blackwell cluster and recouped your investment, Vera Rubin is out. The
      answer NVIDIA sells is that newer hardware runs the same workloads more efficiently,
      so the upgrade economics work. Whether that argument holds for every operator is
      genuinely contested.
    </p>

    <h2>Why it's named after Vera Rubin</h2>
    <p>
      Vera Rubin (1928-2016) was the astronomer who provided the strongest observational
      evidence for dark matter - one of the biggest discoveries in 20th century physics.
      Despite her groundbreaking work, she was never awarded the Nobel Prize, a fact widely
      considered an oversight. Naming an AI architecture after her is a small but meaningful
      recognition of a scientist who shaped modern understanding of the universe.
    </p>

    <h2>What comes after</h2>
    <p>
      NVIDIA has already announced the architecture after Vera Rubin: Feynman, targeted for
      2028 and named after physicist Richard Feynman. The roadmap gives hyperscalers and
      AI labs visibility to plan infrastructure investments years in advance - which is
      itself a competitive advantage for NVIDIA.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        NVIDIA's multi-year roadmap visibility is as strategically important as the hardware
        itself. Customers build long-term infrastructure plans around NVIDIA's architecture
        timeline - which makes switching to a competitor even harder. Vera Rubin isn't just
        a product announcement. It's a signal that NVIDIA intends to keep the compute
        advantage it built in the Blackwell generation.
      </p>
    </div>
  </article>
);

export default VeraRubin;
